<template>
    <form-select :error="error" :value="value" :required="required" v-model="vat" :name="name" :label="name"
                 :options="options" :labelClasses="labelClasses" :inputHolderClasses="inputHolderClasses"/>
</template>
<script>
    export default {
        name: 'vat-select',
        props: {
            name: {
                type: String,
                required: true,
            },
            required: {
                type: Boolean,
                required: false,
            },
            return: {
                type: String,
                required: false,
            },
            error: {
                type: String,
                required: false,
            },
            value: {
                required: false,
                default: null,
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
        },

        created() {
            this.vat = this.options[0];

            if (this.value != null && Number.isInteger(this.value)) {
                this.vat = this.options.find((option) => { return option.value == this.value})
            }
        },

        data() {
            return {
                vat: 21,
                options: [
                    {
                        name: '21%',
                        value: 21,
                    },
                    {
                        name: '9%',
                        value: 9,
                    },
                    {
                        name: '0%',
                        value: 0,
                    },
                ],
            };
        },

        watch: {
            vat: function (val) {
                if (val == null || typeof val == 'undefined') {
                    this.$emit('input', val);
                    return this.$emit('keydown', val);
                }

                this.$emit('input', val.value);
                this.$emit('keydown', val.value);
            },
        },
    };
</script>
